// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AboutSection_wrapper__3ixlm","description":"AboutSection_description__3UW7L","stats":"AboutSection_stats__15o8Y"};